// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Labels = require("../../../reason/clients/components/Labels.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("./FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
let BuyerNeedStatus_buyerNeedV5_graphql = require("../../../__generated__/BuyerNeedStatus_buyerNeedV5_graphql.bs.js");

let convertFragment = BuyerNeedStatus_buyerNeedV5_graphql.Internal.convertFragment;

function BuyerNeedStatus$WithoutErrorBoundary(props) {
  let buyerNeed = RescriptRelay_Fragment.useFragment(BuyerNeedStatus_buyerNeedV5_graphql.node, convertFragment, props.buyerNeed);
  let s = buyerNeed.status;
  switch (s.__typename) {
    case "ActiveBuyerNeed" :
      return null;
    case "ExpiredBuyerNeed" :
      return JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {});
    case "InContractBuyerNeed" :
      return JsxRuntime.jsx(Labels.InContractLabel.make, {});
    case "PurchasedBuyerNeed" :
      return JsxRuntime.jsx(Labels.PurchasedLabel.make, {});
    case "WithdrawnBuyerNeed" :
      return JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected buyer need status ` + s._0);
  }
}

function BuyerNeedStatus(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "buyer need status",
    children: JsxRuntime.jsx(BuyerNeedStatus$WithoutErrorBoundary, {
      buyerNeed: props.buyerNeed
    })
  });
}

let make = BuyerNeedStatus;

exports.make = make;
/* Labels Not a pure module */
